<script lang="ts">
	import type { InputTextProps } from '../types';
	import InputInline from '../InputInline.svelte';
	import InputErrors from '../InputErrors.svelte';

	export let props: InputTextProps;
</script>

<InputInline type="text" bind:props on:keypress on:keyup on:paste {...$$restProps} />
{#if props && props.dirty && props.validation && props.validation.rules && props.validation.rules.length > 0 && !props.validation.valid}
	<InputErrors {props} />
{/if}
